import React, { useEffect, useState } from "react";
import { PlusCircleIcon } from "@heroicons/react/24/outline";
import GlobalTableDropDown from "../GlobalTableDropDown";
import ToggleButton from "../../../commons/ToggleButton";
import AdminAlertSlideOver from "../slideovers/AdminAlertSlideOver";
import { alertMenuItems, globalAlertData } from "../adminData";
import ToggleModal from "../../modals/ToggleModal";
import {
  useCreateAnnouncementMutation,
  useDeleteAnnouncementMutation,
  useGetAllAnnouncementsQuery,
  useUpdateAnnouncementMutation,
} from "../../../../store/admin/announcements";
import Loader from "../../../commons/Loader";
import DeleteSmsModal from "../../../modal/DeleteSmsModal";
import { toast } from "react-toastify";
import { formatDate } from "../../../../utilities/utils";
import GlobalAlertSkeleton from "../../../commons/Skeleton/GlobalAlertSkeleton";

const GlobalAlertsPage = () => {
  const [showMenu, setShowMenu] = useState(null);
  const [activeAlert, setActiveAlert] = useState();
  const [alertSlideOver, setAlertSlideOver] = useState(false);
  const [isDeleteModalShow, setIsDeleteModalShow] = useState(false);
  const [showToggleModal, setShowToggleModal] = useState(false);

  const [
    createAnnouncement,
    {
      isLoading: createAnnouncementLoader,
      isSuccess: createAnnouncementSuccess,
      data: createAnnouncementData,
      isError: createAnnouncementIsError,
      error: createAnnouncementError
    },
  ] = useCreateAnnouncementMutation();
  const [
    updateAnnouncement,
    {
      isLoading: updateAnnouncementLoader,
      isSuccess: updateAnnouncementSuccess,
      data: updateAnnouncementData,
      isError: updateAnnouncementIsError,
      error: updateAnnouncementError
    },
  ] = useUpdateAnnouncementMutation();
  const [
    deleteAnnouncement,
    {
      isLoading: deleteAnnouncementLoader,
      isSuccess: deleteAnnouncementSuccess,
      data: deleteAnnouncementData,
    },
  ] = useDeleteAnnouncementMutation();

  useEffect(() => {
    if (createAnnouncementSuccess && !createAnnouncementLoader) {
      toast.success(createAnnouncementData[0])
      handleClose();
    }
  }, [createAnnouncementSuccess]);

  useEffect(() => {
    if (updateAnnouncementIsError && !updateAnnouncementLoader) {
      toast.error(updateAnnouncementError.data?.error)
      handleClose();
    }
  }, [updateAnnouncementIsError]);

  useEffect(() => {
    if (updateAnnouncementSuccess && !updateAnnouncementLoader) {
      toast.success(updateAnnouncementData[0])
      handleClose();
    }
  }, [updateAnnouncementSuccess]);

  useEffect(() => {
    if (deleteAnnouncementSuccess && !deleteAnnouncementLoader) {
      toast.success(deleteAnnouncementData[0])
      handleClose();
    }
  }, [deleteAnnouncementSuccess]);

  const { data: allAnnouncements } = useGetAllAnnouncementsQuery();
  const announcementsDetails = allAnnouncements?.data ?? {};

  const handleMenuItems = (user, flag) => {
    if (!flag) {
      setShowMenu(user.id);
    } else {
      setShowMenu(null);
    }
  };

  const handleAnnouncementActions = (type, data) => {
    switch (type) {
      case "edit":
        setActiveAlert(data);
        setAlertSlideOver(true);
        break;
      case "duplicate":
        let newObj = (({ id, ...rest }) => rest)(data);
        createAnnouncement(newObj);
        break;
      case "delete":
        setActiveAlert(data);
        setIsDeleteModalShow(true);
        break;
    }
  };

  const handleAlertSlideOverClose = () => {
    setAlertSlideOver(false);
  };

  const handleToggle = (announcement) => {
    let foundAnnouncement = allAnnouncements?.data?.find((ann) => ann.active);
    if (foundAnnouncement && announcement.id != foundAnnouncement.id) {
      toast.warning("Only one global alert can be activated at a time.");
    } else {
      setShowToggleModal(true);
      setActiveAlert(announcement);
    }
  };

  const handleClose = () => {
    setShowToggleModal(false);
    setIsDeleteModalShow(false);
  };

  return (
    <div className="col-span-12">
      <div className="flex justify-between items-center mb-5">
        <h4 className="text-xl md:text-2xl font-bold leading-[130%] md:leading-[180%] text-[#04091E]">
          Global Alerts
        </h4>
        <button
          className="w-12 h-12 flex justify-center items-center rounded-[10px] bg-primary cursor-pointer"
          onClick={() => {
            setActiveAlert(null);
            setAlertSlideOver(true);
          }}
        >
          <PlusCircleIcon className="w-6 h-6 text-white" />
        </button>
      </div>
      {!allAnnouncements ? (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        {[...Array(3)].map(()=> <GlobalAlertSkeleton />)}
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
          {announcementsDetails &&
            announcementsDetails.length > 0 &&
            announcementsDetails?.map((announcement) => (
              <div className="p-5 border border-[#EBEFF3] rounded-md bg-white">
                <div className="flex items-center justify-between pb-3.5 mb-3.5 border-b border-[#EBEFF3]">
                  <h6 className="text-base font-bold leading-[160%] text-customGray capitalize">
                    {announcement.title}
                  </h6>
                  <GlobalTableDropDown
                    data={announcement}
                    showMenu={showMenu === announcement.id}
                    setShowMenu={setShowMenu}
                    callBack={handleMenuItems}
                    menuItems={alertMenuItems}
                    handleDropDownMenu={handleAnnouncementActions}
                  />
                </div>
                <div className="pb-3.5 mb-3.5 border-b border-[#EBEFF3]">
                  <p className="mb-2.5 text-sm font-normal leading-[140%] text-[#485868] md:min-h-[60px] xl:min-h-[80px] xxl:min-h-[60px]">
                    {announcement.content}
                  </p>
                  <div className="flex justify-between items-center">
                    <span className="text-xs md:text-sm font-normal leading-[140%] text-[#485868]">
                      <span className="text-sm font-bold capitalize">
                        start date:
                      </span>{" "}
                      {formatDate(announcement.start_at)}
                    </span>
                    <span className="text-xs md:text-sm font-normal leading-[140%] text-[#485868]">
                      <span className="text-sm font-bold capitalize">
                        end date:
                      </span>{" "}
                      {formatDate(announcement.end_at)}
                    </span>
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-xs font-bold leading-[160%] text-customGray uppercase">
                    Turn ON Alert
                  </span>
                  <ToggleButton
                    isEnabled={announcement.active}
                    onToggle={() => handleToggle(announcement)}
                  />
                </div>
              </div>
            ))}
        </div>
      )}
      {allAnnouncements?.data.length < 1 && (
        <h4 className="flex items-center justify-center mt-5 text-lg text-primary py-6 font-bold">
          No Global Alert Found.
        </h4>
      )}
      <AdminAlertSlideOver
        data={activeAlert}
        show={alertSlideOver}
        setCourseSlideOver={setAlertSlideOver}
        handleClose={handleAlertSlideOverClose}
        createAnnouncement={createAnnouncement}
        updateAnnouncement={updateAnnouncement}
        type={activeAlert ? "Edit" : "Create"}
        loader={createAnnouncementLoader || updateAnnouncementLoader}
      />
      <ToggleModal
        isOpen={showToggleModal}
        handleClose={handleClose}
        handleDelete={() => {
          updateAnnouncement({
            id: activeAlert.id,
            active: !activeAlert.active,
            _method: "PUT",
          });
        }}
        loader={updateAnnouncementLoader}
      />
      <DeleteSmsModal
        isOpen={isDeleteModalShow}
        handleDelete={() => {
          deleteAnnouncement(activeAlert.id);
        }}
        handleClose={handleClose}
        deleteLoader={deleteAnnouncementLoader}
        text="Do you really want to delete this Alert?"
      />
    </div>
  );
};

export default GlobalAlertsPage;
